import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAlerts } from '../../feedback';
import { getManagedAccountsQueryKey } from './useGetManagedUsers';
import { useUserManagementClientContext } from './UserManagementClientContext';

export const useInviteManagedUser = () => {
  const queryClient = useQueryClient();
  const client = useUserManagementClientContext();
  const { showError, showSuccess } = useAlerts();
  const { mutate, status } = useMutation({
    mutationFn: client.inviteManagedUsers,
    onError: () => showError('Server error'),
    onSuccess: (data) => {
      data.forEach(({ email, status }) => {
        status === 'Error'
          ? showError(`Failed to invite ${email}`)
          : showSuccess(`${email} successfully invited`);
      });
      queryClient.invalidateQueries({ queryKey: getManagedAccountsQueryKey });
    },
  });

  return { inviteUsers: mutate, inviteStatus: status };
};
